<template>
  <div>
    <el-dialog
      title="Excel Aktarım"
      :visible.sync="dialogVisible"
      :width="width"
      :before-close="handleClose">

      <p v-if="file !== null"> {{this.file.raw.name}}</p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">İptal Et</el-button>
        <el-button type="primary" @click="handleFile">Onayla</el-button>
      </span>
    </el-dialog>
    <el-upload
        class="upload-demo"
        drag
        accept=".xlsx"
        action=""
        :on-change="pathChange"
        :multiple="false"
        :limit="1"
        :file-list="key_path"
        :auto-upload="false"
        :before-remove="removeImage">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Dosyanızı buraya sürükleyin ya da <em>buraya tıklayın</em></div>
      <div class="el-upload__tip text-danger font-weight-bold" slot="tip">Sadece xlsx formatları kabul edilmektedir.</div>
    </el-upload>
  </div>
</template>

<script>
import 'cropperjs/dist/cropper.css';

export default {
  components: {
	},
  props: ['jobStatusTypeId'],
  data() {
    return {
      width: '30%',
      key_path: [],
      file: null,
      img_url: null,
      dialogVisible: false
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    getWidth() {
      if (window.innerWidth < 760) {
        this.width = "90%";
      } else {
        this.width = "30%";
      }
    },
    pathChange (file, fileList) {
      this.img_url = URL.createObjectURL(file.raw);
      this.file = file;
      this.key_path = fileList;
      this.dialogVisible = true;
    },
    async handleFile() {
      this.$emit('readExcelFile',this.file.raw)
      this.removeImage();
    },
    handleClose(done) {
      this.$confirm('İşlemi iptal etmek istediğinize emin misiniz?')
        .then(()=> {
          this.removeImage();
          done();
        })
        .catch(()=> {});
    },
    defaultSize() {
			return {
				width: 800,
				height: 600,
			};
    },
    removeImage() {
      this.dialogVisible = false
      this.img_url = null;
      this.file = null;
      this.key_path = [];
    }
  }
}
</script>

<style>
.cropper {
  background: transparent;
}
.handler {
    position: absolute;
    right: 15%;
    top: 14%;
    z-index: 1;
    cursor: ne-resize;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.line {
	border-style: dashed;
	border-color: rgba(133, 133, 133, 0.712);
}

.cropper-background {
  background-color: transparent;
}
.el-upload-dragger{
  width: auto!important;
}
.el-upload{
  width: 100%;
}
</style>
